<template>
  <div class="zy-container icons wow fadeInDown" style="margin-top: 40px;">
    <TitleDesc title="强大生态  全域覆盖"
               desc="万丈高楼平地起 以技术为支撑 打造强大的生态服务平台 让你多多维度全方位突破  前呼后应 环环相扣  生态互补！"/>
    <div class="bk" v-for="(row, i) in icons" :key="'row_' + i">
      <div class="bk-item" v-for="(icon, idx) in row" :key="idx"
           :style="{
    backgroundImage: 'url(' + icon.icon + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%'
  }">
        <div class="square1">
          <div class="plan_txt text-center">
            <div class="plan-title">{{ icon.title }}</div>
            <div class="plan-detail">
              <div class="button cursor-pointer"   @click="toJump">前往咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleDesc from "@/views/index/widgets/TitleDesc.vue";
import {WOW} from "wowjs";

export default {
  name: "Industry",
  components: {TitleDesc},
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {
      hover: -1,
      icons: [
        [
          {icon: require('@/assets/images/index/industry/1.jpeg'), title: '餐饮行业'},
          {icon: require('@/assets/images/index/industry/2.jpeg'), title: '零售行业'},
          {icon: require('@/assets/images/index/industry/3.jpeg'), title: '短视频/直播'},
        ],
        [
          {icon: require('@/assets/images/index/industry/4.jpeg'), title: '门店'},
          {icon: require('@/assets/images/index/industry/5.jpeg'), title: '供应链'},
          {icon: require('@/assets/images/index/industry/6.jpeg'), title: 'IM通讯'},
        ]
      ],
    }
  },
  methods: {
    toJump() {
      this.$router.push("/login");
    },
    goLogin: function () {
      this.$router.push("/login");
    },
  }
}
</script>

<style scoped lang="scss">
.square1 {
  width: 100%;
  overflow: hidden; /*是为了防止margin塌陷,触发BFC*/
  padding-bottom: 100%;
  height: 0;
  position: relative;
}

.icons {
  .bk {
    display: flex;

    .bk-item {
      flex: 1;
      margin: 20px;

      .cnt {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      //.cnt:hover {
      //  background: #33333399;
      //}

      .title {
        font-size: 32px;
        color: white;
      }

      .button {
        width: 156px;
        height: 57px;
        font-size: 22px;
        font-weight: 500;
        color: #FFFFFF;
        margin: 18px auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        cursor: pointer;
        border-radius: 6px;
        background-image: linear-gradient(to right, #404DFF, #918BFF);
      }
    }

  }
}

.plan_txt {
  position: absolute;
  width: 100%;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  z-index: 2;
  transition: all 0.6s linear;
}

.plan-title {
  font-size: 32px;
  font-weight: 800;
  color: #FFFFFF;
}

.plan-detail {
  opacity: 0;
  transition: all 0.6s linear;
  overflow: hidden;
}

.bk-item:hover .plan-detail {
  opacity: 1;
}

.bk-item :hover .plan_txt {
  top: 50%;
}

.hvr-float {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.hvr-float:hover, .hvr-float:focus, .hvr-float:active {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
}
</style>
